/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function validateRadio(
  question: any,
  answerList: any,
  indexAnswer: number,
  callback: () => void,
) {
  const minSelectValidationRule = question?.validation_rules?.find(
    (vr) => vr.name === 'min_select',
  )

  if (minSelectValidationRule) {
    const { value } = minSelectValidationRule
    const answerLength = answerList[indexAnswer]?.answer?.length || 0

    if (answerLength < value) {
      callback()
    }
  }
}

export function validateChecklist(
  question: any,
  answerList: any,
  indexAnswer: number,
  callback: () => void,
) {
  const minSelectValidationRule = question?.validation_rules?.find(
    (vr) => vr.name === 'min_select',
  )
  const maxSelectValidationRule = question?.validation_rules?.find(
    (vr) => vr.name === 'max_select',
  )

  const answerLength = answerList[indexAnswer]?.answer?.length || 0

  if (
    minSelectValidationRule &&
    answerLength < minSelectValidationRule.value
  ) {
    callback()
  }

  if (
    maxSelectValidationRule &&
    answerLength > maxSelectValidationRule.value
  ) {
    callback()
  }
}

export function validateText(
  question: any,
  answerList: any,
  indexAnswer: number,
  callback: () => void,
) {
  const minCharacterValidationRule = question?.validation_rules?.find(
    (vr) => vr.name === 'min_character',
  )
  const maxCharacterValidationRule = question?.validation_rules?.find(
    (vr) => vr.name === 'max_character',
  )
  const regexPatternValidationRule = question?.validation_rules?.find(
    (vr) => vr.name === 'regex_pattern',
  )

  const answer = answerList[indexAnswer]?.answer || ''
  const answerLength = answer.length

  if (
    minCharacterValidationRule &&
    answerLength < minCharacterValidationRule.value
  ) {
    callback()
  }

  if (
    maxCharacterValidationRule &&
    answerLength > maxCharacterValidationRule.value
  ) {
    callback()
  }

  if (
    regexPatternValidationRule &&
    !answer.match(regexPatternValidationRule.value)
  ) {
    callback()
  }
}

export function validateFields(
  data: any[],
  selectedPage: number,
  answerList: any[],
  callback: () => void,
) {
  const questions = data[selectedPage]?.questions

  if (!questions || !Array.isArray(questions)) {
    return
  }

  // eslint-disable-next-line no-restricted-syntax
  for (const question of questions) {
    const indexAnswer = answerList.findIndex(
      (answer) => answer.question_id === question.id,
    )

    const answerType = question.answer_type

    if (indexAnswer >= 0) {
      // RULES FOR RADIO TYPES
      if (answerType.includes('radio')) {
        validateRadio(question, answerList, indexAnswer, callback)
      }
      // RULES FOR CHECKLIST TYPES
      if (answerType.includes('checklist')) {
        validateChecklist(question, answerList, indexAnswer, callback)
      }
      // RULES FOR TEXT TYPES
      if (answerType.includes('text')) {
        validateText(question, answerList, indexAnswer, callback)
      }
    }
  }
}
